/** Normalize various variant of a general letter into a single version for easier manage. For example OCG has their own version of full-width alphabet characters and digits. */
export const tcgToOCGLetterMap: Record<string, string> = {
    '０': '0',
    '１': '1',
    '２': '2',
    '３': '3',
    '４': '4',
    '５': '5',
    '６': '6',
    '７': '7',
    '８': '8',
    '９': '9',
    'ａ': 'a',
    'ｂ': 'b',
    'ｃ': 'c',
    'ｄ': 'd',
    'ｅ': 'e',
    'ｆ': 'f',
    'ｇ': 'g',
    'ｈ': 'h',
    'ｉ': 'i',
    'ｊ': 'j',
    'ｋ': 'k',
    'ｌ': 'l',
    'ｍ': 'm',
    'ｎ': 'n',
    'ｏ': 'o',
    'ｐ': 'p',
    'ｑ': 'q',
    'ｒ': 'r',
    'ｓ': 's',
    'ｔ': 't',
    'ｕ': 'u',
    'ｖ': 'v',
    'ｗ': 'w',
    'ｘ': 'x',
    'ｙ': 'y',
    'ｚ': 'z',
    'Ａ': 'A',
    'Ｂ': 'B',
    'Ｃ': 'C',
    'Ｄ': 'D',
    'Ｅ': 'E',
    'Ｆ': 'F',
    'Ｇ': 'G',
    'Ｈ': 'H',
    'Ｉ': 'I',
    'Ｊ': 'J',
    'Ｋ': 'K',
    'Ｌ': 'L',
    'Ｍ': 'M',
    'Ｎ': 'N',
    'Ｏ': 'O',
    'Ｐ': 'P',
    'Ｑ': 'Q',
    'Ｒ': 'R',
    'Ｓ': 'S',
    'Ｔ': 'T',
    'Ｕ': 'U',
    'Ｖ': 'V',
    'Ｗ': 'W',
    'Ｘ': 'X',
    'Ｙ': 'Y',
    'Ｚ': 'Z',
    '「': '｢',
    '」': '｣',
    '、': '､',
    // '/': '／',
    ':': '：',
    // 'ー': 'ｰ',
    // '・': '･',
    // '・': '･',
    // '：': ':',
    '∀': 'Ɐ',
    'ꓯ': 'Ɐ',
    'ꓛ': 'Ɔ',
    'ꓱ': 'Ǝ',
    'ꓞ': 'Ⅎ',
    'ꓨ': '⅁',
    'ꓘ': 'Ʞ',
    'ꓶ': 'Ꞁ',
    '⅂': 'Ꞁ',
    'ꓒ': 'Ԁ',
    'ꓕ': 'Ʇ',
    'Ո': 'ꓵ',
    'ꓥ': 'Ʌ',
    '＜': '<',
    '＞': '>',
    '！': '!',
    '（': '(',
    '）': ')',
    '＆': '&',
    '＇': '\'',
    '＠': '@',
    'Ø': '∅',
};
export const ocgToTCGLetterMap: Record<string, string> = {
    '０': '0',
    '１': '1',
    '２': '2',
    '３': '3',
    '４': '4',
    '５': '5',
    '６': '6',
    '７': '7',
    '８': '8',
    '９': '9',
    'ａ': 'a',
    'ｂ': 'b',
    'ｃ': 'c',
    'ｄ': 'd',
    'ｅ': 'e',
    'ｆ': 'f',
    'ｇ': 'g',
    'ｈ': 'h',
    'ｉ': 'i',
    'ｊ': 'j',
    'ｋ': 'k',
    'ｌ': 'l',
    'ｍ': 'm',
    'ｎ': 'n',
    'ｏ': 'o',
    'ｐ': 'p',
    'ｑ': 'q',
    'ｒ': 'r',
    'ｓ': 's',
    'ｔ': 't',
    'ｕ': 'u',
    'ｖ': 'v',
    'ｗ': 'w',
    'ｘ': 'x',
    'ｙ': 'y',
    'ｚ': 'z',
    'Ａ': 'A',
    'Ｂ': 'B',
    'Ｃ': 'C',
    'Ｄ': 'D',
    'Ｅ': 'E',
    'Ｆ': 'F',
    'Ｇ': 'G',
    'Ｈ': 'H',
    'Ｉ': 'I',
    'Ｊ': 'J',
    'Ｋ': 'K',
    'Ｌ': 'L',
    'Ｍ': 'M',
    'Ｎ': 'N',
    'Ｏ': 'O',
    'Ｐ': 'P',
    'Ｑ': 'Q',
    'Ｒ': 'R',
    'Ｓ': 'S',
    'Ｔ': 'T',
    'Ｕ': 'U',
    'Ｖ': 'V',
    'Ｗ': 'W',
    'Ｘ': 'X',
    'Ｙ': 'Y',
    'Ｚ': 'Z',
    // '｡': '。',
    '｢': '「',
    '｣': '」',
    '､': '、',
    // '／': '/',
    '：': ':',
    // 'ｰ': 'ー',
    // '･': '・',
    // '･': '・',
    // ':': '：',
    '∀': 'Ɐ',
    'ꓯ': 'Ɐ',
    'ꓛ': 'Ɔ',
    'ꓱ': 'Ǝ',
    'ꓞ': 'Ⅎ',
    'ꓨ': '⅁',
    'ꓘ': 'Ʞ',
    'ꓶ': 'Ꞁ',
    '⅂': 'Ꞁ',
    'ꓒ': 'Ԁ',
    'ꓕ': 'Ʇ',
    'Ո': 'ꓵ',
    'ꓥ': 'Ʌ',
    '＜': '<',
    '＞': '>',
    '！': '!',
    '（': '(',
    '）': ')',
    '＆': '&',
    '＇': '\'',
    '＠': '@',
    '∅': 'Ø',
};

// const MirrorableLetter = {
//     'ꟻ': 'Ｆ',
//     '⅃': 'Ｌ',
//     'ꟼ': 'Ｐ',
//     'И': 'Ｎ',
//     'Я': 'Ｒ',
// };

export const ocgNumberCircleMap: Record<string, string> = {
    '(１)': '①',
    '(２)': '②',
    '(３)': '③',
    '(４)': '④',
    '(５)': '⑤',
    '(６)': '⑥',
    '(７)': '⑦',
    '(８)': '⑧',
    '(９)': '⑨',
    '(１０)': '⑩',
    '(１１)': '⑪',
    '(１２)': '⑫',
    '(１３)': '⑬',
    '(１４)': '⑭',
    '(１５)': '⑮',
    '(１６)': '⑯',
    '(１７)': '⑰',
    '(１８)': '⑱',
    '(１９)': '⑲',
    '(２０)': '⑳',
    '(1)': '①',
    '(2)': '②',
    '(3)': '③',
    '(4)': '④',
    '(5)': '⑤',
    '(6)': '⑥',
    '(7)': '⑦',
    '(8)': '⑧',
    '(9)': '⑨',
    '(10)': '⑩',
    '(11)': '⑪',
    '(12)': '⑫',
    '(13)': '⑬',
    '(14)': '⑭',
    '(15)': '⑮',
    '(16)': '⑯',
    '(17)': '⑰',
    '(18)': '⑱',
    '(19)': '⑲',
    '(20)': '⑳',
};

/** Newest at top */
export const copyrightMap = {
    ocg: [
        '©スタジオ・ダイス／集英社・テレビ東京・KONAMI',
        '©高橋和希 スタジオ・ダイス／集英社',
        '©高橋和希／集英社',
    ],
    tcg: [
        '©2020 Studio Dice/SHUEISHA, TV TOKYO, KONAMI',
        '©1996 KAZUKI TAKAHASHI',
        '©KAZUKI TAKAHASHI / SHUEISHA',
    ],
    sc: [
        '©2020 Studio Dice/SHUEISHA, TV TOKYO, KONAMI',
    ],
};

export const editionList = [
    { label: '1st Edition', value: '1<st> Edition' },
    { label: '1ère Édition', value: '1<ère> Édition' },
    { label: '1 . Auflage', value: '1 . Auflage' },
    { label: '1ª Edizione', value: '1ª Edizione' },
    { label: '1ª Edição', value: '1ª Edição' },
    { label: '1ª Edición', value: '1ª Edición' },
];

export const passwordSentenceMap: Record<string, string> = {
    ocg: '※デッキ構築には使用できません。',
    tcg: 'This card cannot be in a Deck.',
    sc: '※不能使用于牌组构筑。',
};

export type CardFormatMode = 'tcg' | 'ocg' | 'sc';

/**
 * Simplified Chinese cards use the OCG template and layout. `sc` is only a
 * presentation/editing mode; serialized card data remains `format: "ocg"`
 * with `region: "ch"` so existing OCG rendering and saved cards stay
 * compatible.
 */
export const getCardFormatMode = (format: string, region: string): CardFormatMode => {
    if (format === 'ocg' && region === 'ch') return 'sc';
    return format === 'ocg' ? 'ocg' : 'tcg';
};

export const isSimplifiedChineseCard = (format: string, region: string) => (
    getCardFormatMode(format, region) === 'sc'
);

/** Official Simplified Chinese master-series terminology supplied from the card database. */
export const tcgToSCTermMap: Record<string, string> = {
    /** monster type */
    'Aqua': '水族',
    'Beast': '兽族',
    'Beast-Warrior': '兽战士族',
    'Creator God': '创造神族',
    'Cyberse': '电子界族',
    'Dinosaur': '恐龙族',
    'Divine-Beast': '幻神兽族',
    'Dragon': '龙族',
    'Fairy': '天使族',
    'Fiend': '恶魔族',
    'Fish': '鱼族',
    'Galaxy': '银河族',
    'Illusion': '幻想魔族',
    'Insect': '昆虫族',
    'Machine': '机械族',
    'Plant': '植物族',
    'Psychic': '念动力族',
    'Pyro': '炎族',
    'Reptile': '爬虫类族',
    'Rock': '岩石族',
    'Sea Serpent': '海龙族',
    'Spellcaster': '魔法师族',
    'Thunder': '雷族',
    'Warrior': '战士族',
    'Winged Beast': '鸟兽族',
    'Wyrm': '幻龙族',
    'Zombie': '不死族',
    /** type */
    'Monster': '怪兽',
    'Spell Card': '魔法卡',
    'Trap Card': '陷阱卡',
    /** subtype */
    'Normal': '通常',
    'Effect': '效果',
    'Ritual': '仪式',
    'Fusion': '融合',
    'Synchro': '同步',
    'Xyz': '超量',
    'Pendulum': '灵摆',
    'Link': '连接',
    'Token': '衍生物',
    'Special Summon': '特殊召唤',
    /** Spell/Trap icon subtype */
    'Equip': '装备',
    'Field': '场地',
    'Quick-Play': '速攻',
    'Continuous': '永续',
    'Counter': '反击',
    /** ability */
    'Tuner': '协调',
    'Gemini': '二重',
    'Flip': '反转',
    'Toon': '卡通',
    'Spirit': '灵魂',
    'Union': '联合',
    /** attribute */
    'LIGHT': '光',
    'DARK': '暗',
    'WATER': '水',
    'FIRE': '炎',
    'EARTH': '地',
    'WIND': '风',
    'DIVINE': '神',
    'SPELL': '魔法',
    'TRAP': '陷阱',
    /** fixed card text */
    [copyrightMap.tcg[0]]: copyrightMap.sc[0],
    [passwordSentenceMap.tcg]: passwordSentenceMap.sc,
};

export const scToTCGTermMap = Object.entries(tcgToSCTermMap).reduce((acc, [tcgTerm, scTerm]) => {
    acc[scTerm] = tcgTerm;
    return acc;
}, {} as Record<string, string>);

/** Automatically convert popular OCG terms into their TCG counterpart. Never introduce machine translation here :'( */
export const ocgToTCGTermMap: Record<string, string> = {
    /** monster type */
    '水族': 'Aqua',
    '獣族': 'Beast',
    '獣戦士族': 'Beast-Warrior',
    '創造神族': 'Creator God',
    'サイバース族': 'Cyberse',
    '恐竜族': 'Dinosaur',
    '幻神獣族': 'Divine-Beast',
    'ドラゴン族': 'Dragon',
    '天使族': 'Fairy',
    '悪魔族': 'Fiend',
    '魚族': 'Fish',
    'ギャラクシー族': 'Galaxy',
    '幻想魔族': 'Illusion',
    '昆虫族': 'Insect',
    '機械族': 'Machine',
    '植物族': 'Plant',
    'サイキック族': 'Psychic',
    '炎族': 'Pyro',
    '爬虫類族': 'Reptile',
    '岩石族': 'Rock',
    '海竜族': 'Sea Serpent',
    '魔法使い族': 'Spellcaster',
    '雷族': 'Thunder',
    '戦士族': 'Warrior',
    '鳥獣族': 'Winged Beast',
    '幻竜族': 'Wyrm',
    'アンデット族': 'Zombie',
    'サイボーグ族': 'Cyborg',
    '天界戦士族': 'Celestial Warrior',
    'ハイドラゴン族': 'High Dragon',
    '魔導騎士族': 'Magical Knight',
    'オメガサイキック族': 'Omega Psychic',
    /** type */
    'モンスター': 'Monster',
    '魔法カード': 'Spell Card',
    '罠カード': 'Trap Card',
    'アクション': 'Action',
    /** subType */
    '通常': 'Normal',
    '効果': 'Effect',
    '儀式': 'Ritual',
    'フュージョン': 'Fusion', // This is Fusion in Rush Duel, when we translate this map into TCG one these two entries will have the same "Fusion" key. We place this one above so it will got overwritten by the normal OCG text for Fusion in the master series.
    '融合': 'Fusion',
    'シンクロ': 'Synchro',
    'エクシーズ': 'Xyz',
    'ペンデュラム': 'Pendulum',
    'リンク': 'Link',
    'マキシマム': 'Maximum',
    'トークン': 'Token',
    '特殊召喚': 'Special Summon',
    'ダークシンクロモンスター': 'Dark Synchro',
    /** ability */
    'チューナー': 'Tuner',
    'デュアル': 'Gemini',
    'リバース': 'Flip',
    'トゥーン': 'Toon',
    'スピリット': 'Spirit',
    'ユニオン': 'Union',
    /** attribute */
    '光': 'LIGHT',
    '闇': 'DARK',
    '水': 'WATER',
    '炎': 'FIRE',
    '地': 'EARTH',
    '風': 'WIND',
    '神': 'DIVINE',
    '魔法': 'SPELL',
    '罠': 'TRAP',
    /** creator copyright */
    [copyrightMap.ocg[2]]: copyrightMap.tcg[2],
    [copyrightMap.ocg[1]]: copyrightMap.tcg[1],
    [copyrightMap.ocg[0]]: copyrightMap.tcg[0],
    /** sample card */
    '{純|ジュン}{狐|こ}': 'Junko',
    [`自分フィールドの効果モンスター×２体以上
①：このカードがモンスターゾーンに存在する限り、相手フィールドのモンスターが効果を発動する度に、その相手の表側表示モンスターにピュアカウンターを１つ置く(最大１つまで）。②：このカードはピュアカウンターが置かれているモンスターが発動した効果を受けない。③：このカードはピュアカウンターが置かれているモンスターとの戦闘では破壊されない。`]: `[2+ Effect Monsters on your field]
Each time an opponent's monster activates its effect, place 1 Pure Counter on that opponent's monster (max. 1) after that effect resolves. Unaffected by activated effects from monster with a Pure Counter. Cannot be destroyed by battle with monsters with a Pure Counter.`,
    '※公式のデュエルでは使用できません。': 'This card cannot be used in a Duel.',
    // eslint-disable-next-line quotes
    '①：１ターンに１度、８００ＬＰを払って発動できる。このカードのＰスケールを1つ上げる。': "Once per turn: You can pay 800 LP, increase this card's Pendulum Scale by 1.",
    [passwordSentenceMap.ocg]: passwordSentenceMap.tcg,
};
export const tcgToOCGTermMap = Object.entries(ocgToTCGTermMap).reduce((acc, cur) => {
    const [ocgTerm, tcgTerm] = cur;
    acc[tcgTerm] = ocgTerm;

    return acc;
}, {
    /** Safe fallback, because the single quote maybe converted into curly single quote */
    'Once per turn: You can pay 800 LP, increase this card’s Pendulum Scale by 1.': '①：１ターンに１度、８００ＬＰを払って発動できる。このカードのＰスケールを1つ上げる。',
} as Record<string, string>);
